import { styles } from './ReviewContentBlock.styles';

export interface ReviewContentBlockProps {
  title: string;
  content?: string | null;
}

export function ReviewContentBlock({
  title,
  content
}: ReviewContentBlockProps) {
  const slots = styles();

  if (!content) {
    return null;
  }

  return (
    <div className={slots.base()}>
      <div className={slots.title()}>{title}</div>
      <div className={slots.content()}>{content}</div>
    </div>
  );
}
